
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'camera-plus': {
    width: 25.4,
    height: 18,
    viewBox: '0 0 25.4 18',
    data: '<path pid="0" d="M1.701 5.223h2v-.7h-2v.7zm15.1.7h-2.5c-.3 0-.5-.1-.6-.3l-1.1-1.6c-.1-.3-.3-.4-.6-.4h-5.2c-.3 0-.5.1-.6.3l-1.1 1.6c-.1.2-.4.4-.6.4h-2.5c-1.1 0-2 .9-2 2v8.1c0 1.1.9 2 2 2h14.8c1.1 0 2-.9 2-2v-8.1c0-1.1-.9-2-2-2zm-1.3 1.9c0 .3-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6c.4 0 .6.3.6.6zm-6.1 8.7c-2.4 0-4.4-1.9-4.4-4.3s2-4.3 4.4-4.4 4.3 1.9 4.4 4.3c-.1 2.5-2 4.4-4.4 4.4zm0-7.7c-1.9 0-3.4 1.5-3.4 3.4s1.5 3.4 3.4 3.4 3.4-1.5 3.4-3.4-1.5-3.4-3.4-3.4zM21.486 2.625v-2.6h1.2v2.6h2.6v1.2h-2.6v2.6h-1.2v-2.6h-2.6v-1.2h2.6z"/>'
  }
})
